<form [formGroup]="interalForm">
    <mat-checkbox class="example-margin pb-3" formControlName="confirmation" (change)='artifactChecked()' >
        <span style="font-size: 16px;white-space: normal !important;" [innerHTML]="artifact.description"></span>
    </mat-checkbox>
</form>